/**
 * DaysStepper — replica product_card.jsx:161-169.
 *
 * Pill rounded brand-soft bg + buttons − / + (tap target ≥44×44, brand-ink) +
 * valor mono center. min=1, max=14.
 *
 * Drimian P6: el cambio de days NO recomputa dose. Solo dispara recalculo
 * del total a entregar (card.entrega) en el padre.
 */

interface Props {
  value: number
  onChange: (n: number) => void
  min?: number
  max?: number
}

export function DaysStepper({ value, onChange, min = 1, max = 14 }: Props) {
  const dec = () => onChange(Math.max(min, value - 1))
  const inc = () => onChange(Math.min(max, value + 1))

  return (
    <span
      className="inline-flex items-center gap-1"
      style={{
        padding: '2px',
        borderRadius: 999,
        background: 'var(--color-surface)',
        border: '1px solid var(--color-brand)',
      }}
    >
      <button
        type="button"
        aria-label="Disminuir días"
        onClick={dec}
        disabled={value <= min}
        className="grid place-items-center text-[18px] font-semibold"
        style={{
          minHeight: 44,
          minWidth: 44,
          width: 44,
          height: 44,
          borderRadius: 999,
          background: 'transparent',
          color: 'var(--color-brand-ink)',
          border: 'none',
          cursor: value <= min ? 'not-allowed' : 'pointer',
          opacity: value <= min ? 0.4 : 1,
        }}
      >
        −
      </button>
      <span
        role="status"
        aria-label={`${value} ${value === 1 ? 'día' : 'días'}`}
        className="text-[14px] font-semibold tabular-nums px-1 min-w-[56px] text-center"
        style={{
          fontFamily: 'var(--font-mono)',
          color: 'var(--color-brand-ink)',
        }}
      >
        {value} {value === 1 ? 'día' : 'días'}
      </span>
      <button
        type="button"
        aria-label="Aumentar días"
        onClick={inc}
        disabled={value >= max}
        className="grid place-items-center text-[18px] font-semibold"
        style={{
          minHeight: 44,
          minWidth: 44,
          width: 44,
          height: 44,
          borderRadius: 999,
          background: 'transparent',
          color: 'var(--color-brand-ink)',
          border: 'none',
          cursor: value >= max ? 'not-allowed' : 'pointer',
          opacity: value >= max ? 0.4 : 1,
        }}
      >
        +
      </button>
    </span>
  )
}
